// Central API configuration for frontend
// 1) Tries runtime window.__API_URL__ (works for drag-and-drop deploys)
// 2) Falls back to REACT_APP_API_URL at build time
// 3) Finally defaults to localhost for local dev
const runtimeApiUrl = typeof window !== 'undefined' && window.__API_URL__;
export const API_ROOT = runtimeApiUrl || process.env.REACT_APP_API_URL || 'http://localhost:5223/api';


